<li class="list-item" [matMenuTriggerFor]="menu">3 More..</li>
<mat-menu #menu="matMenu" class="menu-container">
    <mat-list >
        <mat-list-item class="list-container">
            <h4>Shivakumar</h4>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="list-container">
            <h4>Sivanesan</h4>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item class="list-container">
            <h4>Praveen Putta</h4>
        </mat-list-item>
        <mat-divider></mat-divider>
    </mat-list>
</mat-menu>